import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/WhatsApp_logo.png'
import _imports_1 from '@/assets/pitchyou_logo.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "tenantLogoContainer"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  alt: "WhatsApp logo",
  src: _imports_0,
  class: "logo"
}
const _hoisted_5 = {
  key: 0,
  class: "powered-by-text"
}
const _hoisted_6 = {
  key: 1,
  alt: "Powered by PitchYou",
  src: _imports_1,
  class: "footer-logo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_ctx.currentHeight)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.logoGuid)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.logoPath + _ctx.logoGuid,
              class: "tenantLogo",
              alt: "Logo"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoadingDone)
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.isLoadingDone)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openUrl && _ctx.openUrl(...args)))
          }, "open"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "container-footer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPitchYouTab && _ctx.openPitchYouTab(...args)))
    }, [
      (_ctx.isLoadingDone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "powered by"))
        : _createCommentVNode("", true),
      (_ctx.isLoadingDone)
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ], 4))
}